// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__b18 {
  height: 500px;
}
`, "",{"version":3,"sources":["webpack://./src/common/browser-precondition.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".container {\n  height: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__b18`
};
export default ___CSS_LOADER_EXPORT___;
